import {configuration} from '../../configuration'
import Storage from '@/helpers/storage'
import IndexedDb from '@/modules/indexedDb'
import Store from '@/store'

const i18n = {

    get: (Vue) => {

        return Vue.$i18n.locale

    },

    set: (Vue, lang, refresh) => {

        setLang(Vue, lang, refresh)

    },

    created(Vue) {

        const storageLang = Storage.getItem('lang')

        if (isValidLang(storageLang)) {

            setLang(Vue, storageLang)

        } else {

            const navLang = (window.navigator.userLanguage || window.navigator.language).split('-')[0]

            setLang(Vue, navLang)

        }

    },

    is: {
        english: (vue) => {
            return i18n.get(vue).split('-')[0] === configuration.languages.byName.english
        },
        french: (vue) => {
            return i18n.get(vue).split('-')[0] === configuration.languages.byName.french
        },
        german: (vue) => {
            return i18n.get(vue).split('-')[0] === configuration.languages.byName.german
        },
        arabe: (vue) => {
            return i18n.get(vue).split('-')[0] === configuration.languages.byName.arabe
        }
    }

}

export default i18n

function updateLang(Vue, lang, refresh) {

    Vue.$i18n.locale = lang
    Vue.$router.history.base = `/${lang}`
    Storage.setItem('lang', lang)
    Store.dispatch('setLang', lang)
    IndexedDb.saveLang(lang)
    document.getElementsByTagName('html')[0].setAttribute('lang', lang)

    const path = Vue.$route.redirectedFrom
        ? getPathWithoutLang(Vue.$route.redirectedFrom)
        : window.location.pathname

    let goTo = ''

    const query = window.location.href.split('?')[1]

    Vue.$router.options.routes.forEach(obj => {

        if (obj.path === path) {
            goTo = path

        } else if (obj.path === path.substring(3)) {

            goTo = path.substring(3)
        }
    })

    if(refresh) {
        window.location.href = `${window.location.origin}/${lang}${Vue.$route.fullPath}`
    }


    if (query) {
        goTo = `${goTo}?${query}`
    }

    // rewrite url
    if (goTo && Vue.$route.fullPath !== goTo) {
        Vue.$router.push({path: goTo})
            .catch(() => {
            })
    }

}

function isValidLang(lang) {

    const regex = new RegExp(`^(${configuration.languages.all.join('|')})$`)

    return regex.test(lang)

}

function setLang(Vue, lang = configuration.defaultLanguage, refresh) {

    if (Vue.$i18n && Vue.$i18n.messages[lang]) {

        updateLang(Vue, lang, refresh)

    } else {

        if (Vue.$http) {

            Vue.$http.get(`/i18n/${lang}.json`)
                .then(response => {

                    Vue.$i18n.setLocaleMessage(lang, response.body)

                    updateLang(Vue, lang, refresh)

                })
                .catch(error => {
                })
        }
    }

}

function getPathWithoutLang (path) {
    return path
        .replace(/^\/[a-z]{2}(-[a-z]{2})?\//i, '/')
        .split('?')[0]
}
